<template>
    <section id="catalog">
         <br><br>
        <v-row>
            <v-col cols="12">
                <h2 class="display-1 font-weight-thin text-center">Portafolio</h2>
                <v-responsive class="mt-3 mb-6 mx-auto primary base-divider" max-width="42">
                <v-divider/>
                </v-responsive>
            </v-col>
        </v-row>
    

            <v-container>

                <v-row>
                    <v-col v-for="(item, i) in catalogo" :key="i" class="d-flex child-flex" cols="12" md="3">
                    <v-img :src="item.image" class="grey lighten-2" @click="dato=item, dialog=true" style="cursor:pointer">
                        <template v-slot:placeholder>
                        <v-row class="fill-height ma-0" align="center" justify="center">
                            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                        </v-row>
                        </template>
                    </v-img>
                    </v-col>
                </v-row>

                <v-dialog max-width="1000" v-model="dialog">
                    <v-card>
                        <v-card-text>
                            <v-row justify="center" align="center">
                                <v-col cols="12" md="8">
                                    <br>
                                    <!--v-img src="carousel/1.png" :lazy-src="`https://picsum.photos/10/6?image=${n * 5 + 10}`" class="grey lighten-2"/-->
                                    <v-carousel height="100%" :show-arrows="false">
                                        <div v-if="dato.images">
                                       <v-carousel-item  v-for="(x,y) of dato.images" :key="y">
                                            <v-img :src="x" class="grey lighten-2" contain/>
                                        </v-carousel-item>
                                        </div>
                                        <v-carousel-item v-else>
                                            <v-img :src="dato.image" class="grey lighten-2" contain/>
                                        </v-carousel-item>
                                    </v-carousel>


                                </v-col>
                                <v-col cols="12" md="4">
                                    <div class="my-2 display-1 wrap">
                                        <p>
                                            {{dato.title}}
                                        </p>
                                    </div>
                                    <div class="my-1 text-subtitle-1 text-justify">
                                        {{dato.description}}
                                        <br>
                                        Módulos:
                                        <br>
                                        <ul v-for="(o,i) of dato.modules" :key="i">
                                            <li>{{o}}</li>
                                        </ul>
                                    </div>
                                    <div>
                                        Herramientas:
                                        <br>
                                        <v-chip-group :show-arrows="false">
                                            <v-chip v-for="(l,m) of dato.utils" :key="m">{{ l }}</v-chip>
                                        </v-chip-group>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-dialog>

            </v-container>




    </section>
</template>

<script>

import { db } from '../../firebase'
export default {
    name:'CatalogComponent',
    data:()=>({
        catalogo:[],
        dialog:false,
        dato:{
            description:null,
            image:null,
            modules:[],
            title:null
        }
    }),
    methods:{
        async fetchData(){
            /*
            .onSnapshot((snapshot => {
                snapshot.docChanges().forEach((change) => {

            */
            const arreglo = await db.collection('portfolio').onSnapshot((snap=>{
                snap.docChanges().forEach((change)=>{
                    if (change.type === "added") {
                    
                        this.catalogo.push(change.doc.data())
                    
                    }
                })
            }))
            console.log(arreglo.doc)
        }
    },
    created(){
        this.fetchData()
    }

}
</script>

<style scoped>
.bgcolor{
    background: transparent;
}

</style>>
